module.exports = __webpack_public_path__ + "static/pattern-d4ec3f4aaa88d16d6d1863038880ae96.png";